<template>
  <b-container
    :fluid="true"
    class="px-0"
    :style="{ margin: (loading) ? '0 !important' : 'auto'}"
    v-cloak
  >
 <div v-if="loading" class="min-vh-100 d-flex align-items-center justify-content-center">
    <Loading />
  </div>
  <div v-else class="px-3">
    <UserProfileCard
      name="Account Settings"
      class="mx-auto"
      style="max-width: 800px;"
    >
      <!-- <img
        src="../assets/anchor.png"
        class="hero"
        alt="Logo"
        style="flex: none;"
      /> -->
      <img
        class="hero"
        src="../assets/gunter_Logo-bg.png"
        style="flex: none; margin-left: 60px;"
        height="200"
        width="200"
      />
       <!-- <h1
        class="text-sm font-weight-bold text-gray-600 text-monospace"
      >
      MARLEY
      SHIPPING
    </h1> -->
      <!-- <b-avatar
        square
        variant="light"
        size="40em"
        class="user-icon shadow-sm"
      >
        <template v-slot:default>
          <img
          class="hero"
          src="../assets/FPA_BOL.png"
          style="flex: none;"
          />
        </template>
      </b-avatar> -->
      <!-- <div class="mt-2 mb-4 text-gray-500">PHOTO</div> -->
      <hr class="my-2"/>
      <b-button
        block
        variant="link"
        class="settings-button"
        style="text-decoration: none; box-shadow: none;"
      >
        <b-row class="align-items-center">
          <b-col cols="4" class="text-muted justify-content-start d-flex pl-5">
            FIRST NAME
          </b-col>
          <b-col col class="justify-content-end d-flex pr-5">
            <b-form-input
              v-model="firstName.value"
              :plaintext="!firstName.edit"
              @focus="firstName.edit=true"
              @blur="firstName.edit=false; update('firstName', firstName.value)"
              class="text-right normalize"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-button>
      <hr class="my-0"/>
      <b-button
        block
        variant="link"
        class="settings-button"
        style="text-decoration: none; box-shadow: none;"
      >
        <b-row class="align-items-center">
          <b-col cols="4" class="text-muted justify-content-start d-flex pl-5">
            LAST NAME
          </b-col>
          <b-col col class="justify-content-end d-flex pr-5">
            <!--                TODO: When blur, update the value to the database-->
            <b-form-input
              v-model="lastName.value"
              :plaintext="!lastName.edit"
              @focus="lastName.edit=true"
              @blur="lastName.edit=false; update('lastName', lastName.value)"
              class="text-right normalize"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-button>

      <hr class="my-0"/>
      <b-button
        block
        variant="link"
        class="settings-button"
        style="text-decoration: none; box-shadow: none;"
      >
        <b-row class="align-items-center">
          <b-col cols="4" class="text-muted justify-content-start d-flex pl-5">
            EMAIL
          </b-col>
          <b-col col class="justify-content-end d-flex pr-5">
            <div class="text-right">
              <!-- <div>email@gmail.com</div> -->
              <b-form-input
                readonly
                v-model="email.value"
                :plaintext="!email.edit"
                @focus="email.edit=true"
                @blur="email.edit=false; update('email', email.value)"
                class="text-right normalize"
              ></b-form-input>
            </div>
          </b-col>
        </b-row>
      </b-button>
      <hr class="my-0"/>
    </UserProfileCard>
    <!-- <UserProfilePrivacy /> -->
  </div>
  </b-container>
</template>

<script>
import UserProfileCard from './UserProfileCard.vue';
// import UserProfilePrivacy from './UserProfilePrivacy.vue';
import Loading from './Loading.vue';
import { profile, updateProfile } from '../api/user';

export default {
  name: 'UserProfileAccount',
  components: { UserProfileCard, Loading },
  data() {
    return {
      profile: 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y',
      firstName: {
        value: '',
        edit: false,
      },
      lastName: {
        value: '',
        edit: false,
      },
      email: {
        value: '',
        edit: false,
      },
      originalUser: {},
      emailNotify: false,
      phoneNotify: false,
      loading: true,
    };
  },
  methods: {
    update(key, value) {
      if (key === 'email') {
        if (
          !/^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(this[key].value)
        ) {
          this[key].value = this.originalUser[key];
          return;
        }
      }

      if (value === '') {
        this[key].value = this.originalUser[key];
      } else {
        const data = { data: { [key]: value } };
        updateProfile(data).then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
        }).catch((err) => {
          console.log(err);
          this[key].value = this.originalUser[key];
        });
      }
    },
  },
  mounted() {
    profile().then((resp) => {
      console.log('Successfully GETed');
      console.log(resp);
      this.originalUser = resp.data.result;
      this.firstName.value = resp.data.result.firstName;
      this.lastName.value = resp.data.result.lastName;
      this.email.value = resp.data.result.email;

      this.loading = false;
    }).catch((err) => {
      console.log(err);
    });
  },
};
</script>

<style scoped>

</style>
